import { withJsonFormsControlProps } from '@jsonforms/react';
import { Checkboxes } from './Checkboxes';

const CheckboxesControl = ({ data, handleChange, path, schema, errors, visible, label }) => {
  return (
    <Checkboxes
      value={data}
      updateValue={(newValue) => handleChange(path, newValue)}
      path={path}
      items={schema?.items ?? {}}
      label={label}
      description={schema?.description ?? ''}
      limit={schema?.limit_one_per_column ?? false}
      errors={errors}
      visible={visible}
    />
  );
};

export default withJsonFormsControlProps(CheckboxesControl);
